import React, { useState } from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { StudentSearchPicker } from "./StudentSearchPicker";
import { useLinkProvisional } from "../hooks/useLinkProvisional";

/**
 * Links a provisional (alta rápida) student to a formal one. The teacher/owner
 * picks the real student; on confirm, the provisional's history + hours migrate
 * to them and the provisional is removed.
 */
function LinkProvisionalModal({ show, onHide, planningId, provisional }) {
  const [selected, setSelected] = useState(null);
  const linkMutation = useLinkProvisional(planningId);

  const close = () => {
    setSelected(null);
    onHide();
  };

  const confirm = () => {
    if (!selected || !provisional) return;
    linkMutation.mutate(
      { provisionalId: provisional.id, targetStudentId: selected.id },
      {
        onSuccess: (data) => {
          toast.success(
            `Vinculado a ${data.linked_to?.name ?? "estudiante"} — ` +
              `${data.migrated_grade_cards} clase(s) migrada(s).`
          );
          close();
        },
        onError: (err) => {
          const msg =
            err?.response?.data?.detail ??
            "No se pudo vincular. Intenta nuevamente.";
          toast.error(msg);
        },
      }
    );
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title>Vincular con estudiante registrado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          Provisional: <strong>{provisional?.name}</strong>. Elige al estudiante
          formal con quien corresponde. Sus clases y notas se moverán a ese
          estudiante y las horas se descontarán de su saldo.
        </p>
        <StudentSearchPicker
          selected={selected}
          onSelect={setSelected}
          label="Estudiante formal"
        />
        {selected && (
          <Alert variant="warning" className="small mt-3 mb-0">
            Esta acción no se puede deshacer. El registro provisional se
            eliminará tras migrar su historial.
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={close} style={{ minHeight: 44 }}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={confirm}
          disabled={!selected || linkMutation.isPending}
          style={{ minHeight: 44 }}
        >
          {linkMutation.isPending ? <Spinner size="sm" /> : "Vincular"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export { LinkProvisionalModal };
